export class BeforeAfter {
  constructor(entryObject) {
      this.beforeAfterContainer = document.querySelector(entryObject.id);
      if (!this.beforeAfterContainer) 
      {
            // console.warn(`BeforeAfter container with id ${entryObject.id} not found.`);
            return;
      }
      this.before = this.beforeAfterContainer.querySelector('.bal-before');
      this.beforeText = this.beforeAfterContainer.querySelector('.bal-beforePosition');
      this.afterText = this.beforeAfterContainer.querySelector('.bal-afterPosition');
      this.handle = this.beforeAfterContainer.querySelector('.bal-handle');
      this.widthChange = 0;

      // Bind event handlers to maintain context
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.handleEndEvent = this.handleEndEvent.bind(this);
      this.onResize = this.onResize.bind(this);

      // Initialize styles
      const balBeforeInset = this.beforeAfterContainer.querySelector('.bal-before-inset');
      if (balBeforeInset) {
          balBeforeInset.style.width = `${this.beforeAfterContainer.offsetWidth}px`;
      }
      if (this.before) {
          this.before.style.width = "50%";
      }
      if (this.handle) {
          this.handle.style.left = "50%";
      }
      

      // Event listeners
      this.beforeAfterContainer.addEventListener("touchstart", this.onTouchStart, { passive: true });
      this.beforeAfterContainer.addEventListener("mousemove", this.onMouseMove);
      this.beforeAfterContainer.addEventListener('touchend', this.handleEndEvent);
      this.beforeAfterContainer.addEventListener('mouseup', this.handleEndEvent);
      window.addEventListener('resize', this.onResize);
  }

  onTouchStart(e) {
      this.beforeAfterContainer.addEventListener("touchmove", this.onTouchMove, { passive: true });
  }

  onTouchMove(e) {
      // 创建一个自定义事件, 通知外部组件开始滑动
      const event = new CustomEvent('slide-start', {
          bubbles: true,
          cancelable: true,
      });

      // 触发自定义事件
      this.beforeAfterContainer.dispatchEvent(event);

      let containerWidth = this.beforeAfterContainer.offsetWidth;
      let currentPoint = e.changedTouches[0].clientX;
      let startOfDiv = this.beforeAfterContainer.getBoundingClientRect().left;
      let modifiedCurrentPoint = currentPoint - startOfDiv;

      if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < this.beforeAfterContainer.offsetWidth - 10) {
          let newWidth = (modifiedCurrentPoint * 100) / containerWidth;
          this.before.style.width = `${newWidth}%`;
          this.handle.style.left = `${newWidth}%`;
      }
  }

  onMouseMove(e) {
      let containerWidth = this.beforeAfterContainer.offsetWidth;
      this.widthChange = e.offsetX;
      let newWidth = (this.widthChange * 100) / containerWidth;

      if (e.offsetX > 10 && e.offsetX < this.beforeAfterContainer.offsetWidth - 10) {
          this.before.style.width = `${newWidth}%`;
          this.handle.style.left = `${newWidth}%`;
      }
  }

  handleEndEvent(e) {
      // 创建一个自定义事件, 通知外部组件结束滑动
      const event = new CustomEvent('slide-end', {
          bubbles: true,
          cancelable: true,
      });

      // 触发自定义事件
      this.beforeAfterContainer.dispatchEvent(event);
  }

  onResize() {
      this.beforeAfterContainer.querySelector('.bal-before-inset').style.width = `${this.beforeAfterContainer.offsetWidth}px`;
  }

  destroy() {

      if (!this.beforeAfterContainer) return;

      // 移除所有事件监听器
      this.beforeAfterContainer.removeEventListener("touchstart", this.onTouchStart, { passive: true });
      this.beforeAfterContainer.removeEventListener("touchmove", this.onTouchMove, { passive: true });
      this.beforeAfterContainer.removeEventListener("mousemove", this.onMouseMove);
      this.beforeAfterContainer.removeEventListener('touchend', this.handleEndEvent);
      this.beforeAfterContainer.removeEventListener('mouseup', this.handleEndEvent);
      window.removeEventListener('resize', this.onResize);

      // 重置样式
      this.beforeAfterContainer.querySelector('.bal-before-inset').style.width = "";
      this.before.style.width = "";
      this.handle.style.left = "50%";

      // 触发 'slide-end' 事件以清除任何滑动状态
      this.handleEndEvent();
  }
}